import React, { useMemo } from "react";
import {
  useUpcomingEvents,
  useEventHighlights,
  useLiveEvents,
  useLatestEvents
} from "modules/events/hooks";
import ContentSlider from "../../components/ContentSlider/ContentSlider";
import ImageBanner from "../../components/ImageBanner/ImageBanner";
import EventSlider from "../../components/EventSlider/EventSlider";
import { SPORT_ASSETS } from "modules/sport/constants";
import { Sport } from "modules/sport/types";
import { Pricing } from "pages/Static";

export const Content = ({ sport }: { sport: Sport }) => {
  const { eventsUpcoming } = useUpcomingEvents(sport.uuid);
  const { eventsLive } = useLiveEvents(sport.uuid);
  const { eventsLatest } = useLatestEvents(sport.uuid);
  const { highlights } = useEventHighlights(sport.uuid);

  const sportImage = useMemo(() => {
    if (!sport) return;

    return SPORT_ASSETS[sport.name];
  }, [sport]);

  const eventsDoc = [
    {
      name: "Knights Boulanger",
      league: "CNR",
      date: "01-11-2024",
      images: [
        {
          url: "/Staidium_Basketball.jpg"
        }
      ]
    },
    {
      name: "Chicago Blues",
      league: "CSDHL",
      date: "01-05-2024",
      images: [
        {
          url: "/Staidium_IceHockey.jpg"
        }
      ]
    },
    {
      name: "Legacy VTC Tournament",
      league: "High Performance",
      images: [
        {
          url: "/Staidium_Soccer.jpg"
        }
      ]
    },
    {
      name: "Phoenix Field",
      league: "ST. LOIUS HIERACHY 3",
      images: [
        {
          url: "/Staidium_Volleyball.jpg"
        }
      ]
    }
  ];

  return (
    <div id="sport-page">
      <ImageBanner imgSrc={sportImage ?? ""} />
      <ContentSlider
        title={`Live ${sport.name === 'icehockey' ? 'Ice Hockey' : sport.name} Events`}
        data={eventsLive}
        event={true}
        sport={sport.name}
        type={"events"}
      />

      <ContentSlider
        title={`Latest ${sport.name === 'icehockey' ? 'Ice Hockey' : sport.name} Events`}
        data={eventsLatest && eventsLatest}
        event={true}
        sport={sport.name}
        type={"events"}
      />

      <ContentSlider
        title={`Upcoming ${sport.name === 'icehockey' ? 'Ice Hockey' : sport.name} Events`}
        data={eventsUpcoming}
        event={true}
        sport={sport.name}
        type={"events"}
      />

      <ImageBanner carousel={false} imgSrc={"/product/Gamepass.jpg"} />

      <ContentSlider
        style={{ paddingBottom: "40px" }}
        title={`${sport.name === 'icehockey' ? 'Ice Hockey' : sport.name} Highlights`}
        data={highlights}
        event={true}
        sport={sport.name}
        type={"highlight"}
      />

      <Pricing />
    </div>
  );
};
